import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FIELD_CONFIG } from './field-tokens';

@Component({
  selector: 'app-field-label',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  template: `
    <p class="text-sm text-surface-500 dark:text-surface-400 leading-relaxed">
      {{ config.placeholder || config.label }}
    </p>
  `
})
export class LabelFieldComponent {
  readonly config = inject(FIELD_CONFIG);
}
